module.exports = __webpack_public_path__ + "media/מתנה.7a4324bd.mp3";